/**
 * The VAT rates of planned items, in the order the dialog offers them.
 */
export const vatRates = ['NONE', 'REDUCED', 'STANDARD'];

const percentages: Record<string, number> = {
    NONE: 0,
    REDUCED: 7,
    STANDARD: 19,
};

export const vatRatePercent = (vatRate: string): number => percentages[vatRate] ?? 0;
